export enum TypingStatus {
  Typing = 0,
  StopTyping = 1,
}



// WEBPACK FOOTER //
// ./src/app/shared/textbox/typing-status.ts